import React from 'react';
import { motion } from 'framer-motion';
import { LiveTenderFeed } from './ui/LiveTenderFeed';
import { Button } from './ui/Button';
import { PlayIcon, CheckIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function DemoSection() {
  const navigate = useNavigate();
  return <section id="demo" className="py-24 bg-white relative overflow-hidden" data-id="element-370">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-100 to-transparent" data-id="element-371"></div>
      <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-gradient-radial from-yellow-50 to-transparent opacity-40" data-id="element-372"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-373">
        <div className="text-center mb-16" data-id="element-374">
          <span className="inline-block px-3 py-1 bg-blue-50 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-375">
            Démonstration
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-376">
            Visualisez nos données en temps réel
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-377">
            Accédez à plus de 1 000 nouveaux appels d'offres chaque jour,
            vérifiés et enrichis par nos experts
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-378">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="h-[28rem] relative" data-id="element-379">
            <div className="absolute -inset-2 bg-gradient-to-br from-blue-100 to-yellow-100 rounded-xl opacity-50 blur-lg" data-id="element-380"></div>
            <div className="absolute inset-0 bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-381">
              <LiveTenderFeed data-id="element-382" />
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="flex flex-col items-center lg:items-start" data-id="element-383">
            <h3 className="text-2xl md:text-3xl font-bold text-blue-900 mb-6" data-id="element-384">
              Ne manquez plus aucune opportunité
            </h3>
            <ul className="space-y-5 mb-10 text-left" data-id="element-385">
              {["Filtrez par secteur d'activité, pays, montant ou date", 'Configurez des alertes personnalisées', 'Accédez aux documents et annexes complets', "Suivez vos appels d'offres favoris"].map((item, index) => <motion.li key={index} className="flex items-start bg-gray-50 p-4 rounded-lg shadow-sm" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.3,
              delay: index * 0.1
            }} viewport={{
              once: true
            }} data-id="element-386">
                  <div className="mr-3 mt-0.5 flex-shrink-0" data-id="element-387">
                    <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center" data-id="element-388">
                      <CheckIcon size={16} className="text-green-600" data-id="element-389" />
                    </div>
                  </div>
                  <div className="text-gray-700 font-medium" data-id="element-390">{item}</div>
                </motion.li>)}
            </ul>
            <div className="space-y-4 w-full md:w-auto" data-id="element-391">
              <Button variant="primary" size="lg" className="flex items-center shadow-lg shadow-yellow-500/20 w-full md:w-auto justify-center" onClick={() => navigate('/demo')} data-id="element-392">
                <PlayIcon size={20} className="mr-2" data-id="element-393" />
                Voir la démo en direct
              </Button>
              <div className="text-center md:text-left text-sm text-gray-500" data-id="element-394">
                Aucune carte de crédit requise • Annulation à tout moment
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}